import { Close as CloseIcon } from '@mui/icons-material';

import { DialogTitle, IconButton, useTheme } from '@mui/material';
import { default as React } from 'react';

interface IProps {
  onClose: () => void;
  title?: string;
}

export const ModalTitle: React.FC<IProps> = ({ onClose, title = 'Choose default template' }) => {
  const theme = useTheme();
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {title}
      <IconButton onClick={onClose} sx={{ p: 0 }} data-action="close_btn">
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
};
